module.exports = __webpack_public_path__ + "static/img/1907_phase_function_Paper_PointsHejduk_Prediction.6567189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1907_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2bh0
// module chunks = 0